import React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { MenuOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

import styles from "./index.module.css"

const SortableQuestionItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: 'relative',
  }

  return (
    <div ref={setNodeRef} style={style}>
      <div 
        className={styles.dragHandle} 
        {...listeners} 
        {...attributes}
      >
        <MenuOutlined className={styles.dragIcon} />
      </div>
      {children}
    </div>
  )
}

SortableQuestionItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node
}

export default SortableQuestionItem
